<template>

    <mainComponent
        title="Administration - Gestion utilisateur"
    >
        <adminUserManage></adminUserManage>
    </mainComponent>

</template>

<script>
    import mainComponent from '../../mainComponent.vue'
    import adminUserManage from './adminUser/manageUser.vue'

    export default {
        components: {mainComponent, adminUserManage},
        data() {
            return {}
        },
        created() {
        },
        mounted() {

        },
        methods: {},
        computed: {},
    }
</script>